import React from 'react';
import { statusInfo, temperatureInfo, channelInfo, LEADS_TEST_VISUALS } from './config';

// Estilos del módulo de Leads. Mismos valores que el objeto S de App.js (que no se puede importar
// desde aquí sin crear una importación circular), con algunos añadidos propios.
export const L = {
  overlay: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' },
  modal: { backgroundColor: 'var(--b-1e293b)', borderRadius: '12px', width: '94vw', maxWidth: '920px', height: '88vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 40px rgba(0,0,0,0.4)', border: '1px solid var(--l-374151)', overflow: 'hidden' },
  modalMobile: { backgroundColor: 'var(--b-1e293b)', width: '100vw', height: '100dvh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  head: { padding: '14px 16px 0', borderBottom: '1px solid var(--l-334155)', flexShrink: 0 },
  body: { flex: 1, overflowY: 'auto', padding: '14px 16px 24px' },
  title: { color: 'var(--t-f1f5f9)', fontSize: '1.15rem', fontWeight: 600, margin: 0 },
  closeBtn: { background: 'transparent', border: 'none', color: 'var(--t-9ca3af)', fontSize: '22px', cursor: 'pointer', width: '36px', height: '36px', borderRadius: '6px', flexShrink: 0 },
  input: { width: '100%', boxSizing: 'border-box', padding: '10px', backgroundColor: 'var(--b-374151)', border: '1px solid var(--l-4b5563)', borderRadius: '6px', color: 'var(--t-f1f5f9)', fontSize: '14px', marginBottom: '12px', fontFamily: 'inherit' },
  textarea: { width: '100%', boxSizing: 'border-box', padding: '10px', backgroundColor: 'var(--b-374151)', border: '1px solid var(--l-4b5563)', borderRadius: '6px', color: 'var(--t-f1f5f9)', fontSize: '14px', minHeight: '80px', resize: 'vertical', fontFamily: 'inherit', marginBottom: '12px' },
  label: { color: 'var(--t-e5e7eb)', fontSize: '13px', fontWeight: 500, marginBottom: '5px', display: 'block' },
  button: { backgroundColor: 'var(--b-f59e0b)', color: '#1f2937', border: 'none', padding: '10px 18px', borderRadius: '6px', fontWeight: 600, cursor: 'pointer', fontSize: '14px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', textDecoration: 'none' },
  secondary: { backgroundColor: 'var(--b-374151)', color: 'var(--t-f1f5f9)', border: '1px solid var(--l-4b5563)', padding: '8px 14px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', textDecoration: 'none' },
  danger: { backgroundColor: 'var(--b-7f1d1d)', color: 'var(--t-fecaca)', border: '1px solid var(--l-7f1d1d)', padding: '8px 14px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  card: { backgroundColor: 'var(--b-0f172a)', border: '1px solid var(--l-334155)', borderRadius: '10px', padding: '12px', display: 'grid', gap: '6px' },
  section: { backgroundColor: 'var(--b-0f172a)', border: '1px solid var(--l-334155)', borderRadius: '10px', padding: '12px 14px', marginBottom: '12px' },
  sectionTitle: { color: 'var(--t-f1f5f9)', fontSize: '0.95rem', fontWeight: 600, margin: '0 0 10px' },
  muted: { color: 'var(--t-9ca3af)', fontSize: '0.8rem' },
  error: { backgroundColor: 'var(--b-450a0a)', border: '1px solid var(--l-7f1d1d)', color: 'var(--t-fca5a5)', borderRadius: '6px', padding: '8px 10px', fontSize: '0.85rem', margin: '0 0 12px' },
  ok: { backgroundColor: 'var(--b-052e16)', border: '1px solid var(--l-166534)', color: 'var(--t-86efac)', borderRadius: '6px', padding: '8px 10px', fontSize: '0.85rem', margin: '0 0 12px' },
  warn: { backgroundColor: 'var(--b-422006)', border: '1px solid #92400e', color: 'var(--t-fde68a)', borderRadius: '6px', padding: '8px 10px', fontSize: '0.82rem', lineHeight: 1.45, margin: '0 0 12px' },
  grid2: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', columnGap: '12px' }
};

export function StatusBadge({ status }) {
  const s = statusInfo(status);
  return (
    <span style={{ backgroundColor: s.bg, color: s.fg, fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: '999px', whiteSpace: 'nowrap' }}>
      {s.label}
    </span>
  );
}

export function TemperatureTag({ temperature }) {
  const t = temperatureInfo(temperature);
  return <span style={{ color: t.color, fontSize: '0.75rem', whiteSpace: 'nowrap' }}>{t.label}</span>;
}

export function TestTag() {
  if (!LEADS_TEST_VISUALS) return null;
  return (
    <span style={{ backgroundColor: 'var(--b-422006)', color: 'var(--t-fde68a)', fontSize: '0.65rem', fontWeight: 700, padding: '1px 6px', borderRadius: '999px', whiteSpace: 'nowrap' }}>
      🧪 PRUEBA
    </span>
  );
}

export function ChannelTag({ channel }) {
  const c = channelInfo(channel);
  const online = c.key === 'online';
  return (
    <span title={online ? 'Lead online (entra desde el CRM)' : c.key === 'telefono' ? 'Cliente que llamó a la tienda' : 'Lead presencial (cliente en tienda)'}
      style={{ border: `1px solid ${online ? 'var(--l-1e3a8a)' : 'var(--l-4b5563)'}`, color: online ? 'var(--t-93c5fd)' : 'var(--t-cbd5e1)', fontSize: '0.65rem', fontWeight: 700, padding: '1px 6px', borderRadius: '999px', whiteSpace: 'nowrap' }}>
      {c.icon} {c.label.toUpperCase()}
    </span>
  );
}

// Botones de opción (una sola elegida).
export function Chips({ options, value, onChange, disabled, small }) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
      {options.map(o => {
        const active = o.key === value;
        return (
          <button
            key={o.key}
            type="button"
            disabled={disabled}
            aria-pressed={active}
            onClick={() => onChange(o.key)}
            style={{
              backgroundColor: active ? 'var(--b-f59e0b)' : 'transparent',
              color: active ? '#1f2937' : 'var(--t-cbd5e1)',
              border: `1px solid ${active ? 'var(--l-f59e0b)' : 'var(--l-4b5563)'}`,
              borderRadius: '999px', padding: small ? '3px 10px' : '6px 12px',
              fontSize: small ? '0.75rem' : '0.85rem', fontWeight: active ? 700 : 500,
              cursor: disabled ? 'default' : 'pointer', whiteSpace: 'nowrap'
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export function Field({ label, htmlFor, children, hint }) {
  return (
    <div>
      <label style={L.label} htmlFor={htmlFor}>{label}</label>
      {children}
      {hint && <div style={{ ...L.muted, marginTop: '-8px', marginBottom: '12px' }}>{hint}</div>}
    </div>
  );
}
